import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api, getListItems } from '../../services/api'
import { useSiteContent, sectionField } from '../../hooks/useSiteContent'

const DEFAULT_IMG = {
  1: '/assets/img/normal/about_1_1.jpg',
  2: '/assets/img/normal/about_1_2.jpg',
  3: '/assets/img/normal/about_1_3.jpg',
  side: '/assets/img/normal/about-slide-img.png',
}

function AboutOne() {
    const { content } = useSiteContent('home')
    const [galleryImgs, setGalleryImgs] = useState([])
    const c = (key, fallback) => sectionField(content, 'about', key, fallback)

    useEffect(() => {
        let cancelled = false
        api.getGallery('home_about')
            .then((res) => {
                if (cancelled) return
                setGalleryImgs(getListItems(res).map((item) => item.image).filter(Boolean))
            })
            .catch(() => {})
        return () => { cancelled = true }
    }, [])

    const img1 = galleryImgs[0] || c('image_1', DEFAULT_IMG[1])
    const img2 = galleryImgs[1] || c('image_2', DEFAULT_IMG[2])
    const img3 = galleryImgs[2] || c('image_3', DEFAULT_IMG[3])

    return (
        <div
            className="about-area position-relative overflow-hidden space"
            id="about-sec"
        >
            <div className="container shape-mockup-wrap">
                <div className="row">
                    <div className="col-xl-6">
                        <div className="img-box1">
                            <div className="img1">
                                <img src={img1} alt={c('title', 'About Travel With Ammar')} />
                            </div>
                            <div className="img2">
                                <img src={img2} alt="" />
                            </div>
                            <div className="img3">
                                <img src={img3} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="ps-xl-4 ms-xl-2">
                            <div className="title-area mb-20 pe-xl-5 me-xl-5">
                                <span className="sub-title style1 ">{c('subtitle', "Let's Go Together")}</span>
                                <h2 className="sec-title mb-20 pe-xl-5 me-xl-5 heading">
                                    {c('title', 'Plan Your Trip With us')}
                                </h2>
                                <p className="sec-text mb-30">
                                    {c('body', 'There are many variations of passages of available but the majority have suffered alteration in some form, by injected hum randomised words which don\'t look even slightly.')}
                                </p>
                            </div>
                            <div className="about-item-wrap">
                                <div className="about-item">
                                    <div className="about-item_img">
                                        <img src="/assets/img/icon/map3.svg" alt="" />
                                    </div>
                                    <div className="about-item_centent">
                                        <h5 className="box-title">{c('feature_1_title', 'Exclusive Trip')}</h5>
                                        <p className="about-item_text">
                                            {c('feature_1_text', 'There are many variations of passages of available but the majority.')}
                                        </p>
                                    </div>
                                </div>
                                <div className="about-item">
                                    <div className="about-item_img">
                                        <img src="/assets/img/icon/guide.svg" alt="" />
                                    </div>
                                    <div className="about-item_centent">
                                        <h5 className="box-title">{c('feature_2_title', 'Professional Guide')}</h5>
                                        <p className="about-item_text">
                                            {c('feature_2_text', 'There are many variations of passages of available but the majority.')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-35">
                                <Link to={c('cta_url', '/about')} className="th-btn style3 th-icon">
                                    {c('cta_text', 'Learn More')}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="shape-mockup about-shape movingX d-none d-xxl-block"
                    style={{ bottom: '0%', right: '-11%' }}
                >
                    <img src={c('side_image', DEFAULT_IMG.side)} alt="" />
                </div>
                <div
                    className="shape-mockup about-rating d-none d-xxl-block"
                    style={{ bottom: '50%', right: '-20%' }}
                >
                    <i className="fa-sharp fa-solid fa-star" />
                    <span>{c('rating_badge', '4.9k')}</span>
                </div>
            </div>
        </div>
    )
}

export default AboutOne
